import API from "../config/api.js";

export const ProductService = {
  getProductList(search, page = 1) {
    return API.get(`api/products/list/se=${search}`, { params: { page: page } });
  },

  getProductListAll(search, page = 1) {
    return API.get(`api/products/listAll/se=${search}`, { params: { page: page } });
  },

  getProductInfo(uuid) {
    return API.get(`api/products/info/${uuid}`);
  },

  create(data) {
    return API.post(`api/products/create`, data);
  },

  updateProduct(uuid, data) {
    return API.put(`api/products/info/update/${uuid}`, data);
  },

  getScales() {
    return API.get(`api/product/units`);
  },

  getProductCategories() {
    return API.get(`api/products/categories/listall`);
  },
  getUnits() {
    return API.get(`api/products/units/list`);
  },
  getGlAccounts() {
    return API.get(`api/products/gl_accounts/list`);
  },
  createCategory(data) {
    return API.post("/api/products/category_create", data);
  },

  dropProduct(uuid) {
    return API.delete(`/api/products/delete/${uuid}`);
  },
};
